import React from 'react';
import SectionLowerBanners from './section_lower_banners';
import SectionSelectedPlaceSummary from './section_selected_place_summary';
import SectionReservationSummary from './section_reservation_summary';

const SectionPlace = ({ event, setEvent, setEventDateError, placeError, onSelectPlace, selectedPlace, clearSelectedPlace, reservationSummary, onEditReservation, onCancelReservation, circle }) => {

  const onEventDateError = React.useCallback(() => {
    if (!event.event_date || !event.event_end_datetime) {
      setEventDateError('イベント日時を入力してください。');
    } else {
      setEventDateError('');
    }
  }, [event]);

  return (
    <section id="place">
      <>
      <div className="container col-md-8 col-lg-6">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-1 mt-3 d-inline-block">
          場所
          <span className="text-fz-14px text-fw-bold text-orange mb-1 mt-1 ml-2 d-inline-block">
            必須
          </span>
        </p>
        {/* <p className="text-fz-16px text-fw-bold mb-0">
          人気の会場を<span className="text-danger">こちらから簡単予約/選択</span>できるようになりました！🎉<span className="text-fz-14px">（会場画像をクリック！）</span>
        </p>
        <p className="text-fz-14px mb-0"><span className="text-black-50">
        予約必須の会場は<span className="text-fw-bold">こちらから予約が必要</span>です。
        </span></p>
        <p className="text-fz-14px"><span className="text-black-50">
          予約不要の際は会場を選択するだけで構いません。
        </span></p> */}
        <p className="text-fz-13px font-weight-bold mb-2">
          ネタ探しに困ったら...
        </p>
      </div>
      <SectionLowerBanners onSelectPlace={onSelectPlace} prefId={circle?.pref_id} />
      {selectedPlace && selectedPlace.is_reservation_required === false && (
        <SectionSelectedPlaceSummary place={selectedPlace} onClear={clearSelectedPlace} />
      )}
      {reservationSummary && (
        <SectionReservationSummary
          summary={reservationSummary}
          onEdit={onEditReservation}
          onCancel={onCancelReservation}
        />
      )}
      </>
      <div
        className={`shadow-sm mb-0 ${
          !!placeError ? 'bg-light-pink' : 'bg-white'
        }`}
      >
        <div className="container col-md-8 col-lg-6 p-3_5">
          {placeError && (
            <p className="text-danger text-fz-small mb-0">{placeError}</p>
          )}
          <div className="row justify-content-between p-1">
            <p className="col-4 pr-2 m-0">開催場所</p>
            <input
              id="place"
              value={event.place || ''}
              onChange={(e) => {
                setEvent((prev) => ({ ...prev, place: e.target.value }))
                if (e.target.value === '') {
                  clearSelectedPlace()
                }
              }
              }
              onClick={() => onEventDateError()}
              className="col-8 p-0 textarea--eventreport text-right"
              placeholder="新宿駅西口"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionPlace;
